import '@css/bestcosme/common.scss'
import '@css/bestcosme/teaser.scss'

$(function() {
  function updateCountdown() {
    // 設定目標日期 (UTC+8)
    const targetDate = new Date('2025-11-19T10:59:59+08:00');
    const now = new Date();

    // 計算時間差（毫秒）
    const diff = targetDate - now;

    if (diff <= 0) {
      // 如果已經過了目標日期
      $('#days').text('00');
      $('#hours').text('00');
      $('#minutes').text('00');
      //$('#secs').text('00');
      return;
    }

    // 轉換為天、小時、分鐘
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    // const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // 更新顯示
    $('#days').text(days.toString().padStart(2, '0'));
    $('#hours').text(hours.toString().padStart(2, '0'));
    $('#minutes').text(minutes.toString().padStart(2, '0'));
    // $('#secs').text(seconds.toString().padStart(2, '0'));
  }
  // 立即執行一次
  updateCountdown();

  // 每30秒更新一次
  setInterval(updateCountdown, 30000);
});